import cn from 'classnames';
import { FC } from 'react';

import { getFile } from 'ApiPackage/MainModule/services/core';
import { saveFile } from 'CorePackage/MainModule/common/saveFile';

import styles from './DownloadButton.module.scss';

interface IDownloadButtonProps {
  className?: string;
  url?: string;
}

export const DownloadButton: FC<IDownloadButtonProps> = ({ className, url, children }) => {
  const onClick = async () => {
    try {
      const fileName = url?.split('/').pop();
      if (url && fileName) {
        const res = await getFile(url);
        saveFile(res, fileName);
      }
    } catch (err) {
      //
    }
  };

  return (
    <button className={cn(styles.Button, className)} type="button" onClick={onClick}>
      {children}
    </button>
  );
};
